import type { FaireProductEntity } from "../../entity_types/product";

export const p_t2fmkuujfn: FaireProductEntity = {
  token: "p_t2fmkuujfn",
  type: "product",
  name: "Happily Divorced Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/135cbaec6ba9c94514dda88e33a3018f09b072538508070570c3437b312257e8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4842824663fb0abfc8bf989f1399e22f4c8d4090d1711d5f65bc6ec3ce47945c.jpeg",
    "https://cdn.faire.com/fastly/37d3c361bf0a43cd3452084e12b2e9ffb0454429f767cc4aa387e9babf139bbd.jpeg",
    "https://cdn.faire.com/fastly/3939c9867e98def82bdff61083c489236c52c57662dbda2375eed30b3a29605d.jpeg",
    "https://cdn.faire.com/fastly/fdcd19f97381e5679875c6754d62f82da9edf845fa0bfd14b7a0f83589379ef8.jpeg"
  ],
  priceDollars: 6.75,
  description: "These comfy babies are for anyone who's rediscovered the joys of sleeping diagonally again! 😝\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:53.218Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
